export type BatchRecipientFileRow = {
  recipient: string;
  amount: string;
};

function parseCsvRows(text: string): string[][] {
  const rows: string[][] = [];
  let row: string[] = [];
  let field = "";
  let inQuotes = false;

  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    const next = text[i + 1];

    if (char === '"') {
      if (inQuotes && next === '"') {
        field += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
      continue;
    }

    if (char === "," && !inQuotes) {
      row.push(field);
      field = "";
      continue;
    }

    if ((char === "\n" || char === "\r") && !inQuotes) {
      if (char === "\r" && next === "\n") i++;
      row.push(field);
      rows.push(row);
      row = [];
      field = "";
      continue;
    }

    field += char;
  }

  row.push(field);
  rows.push(row);
  return rows;
}

export async function parseBatchRecipientCsvFile(
  file: File,
  { recipientHeaderPattern = /address|wallet|recipient/i } = {},
): Promise<BatchRecipientFileRow[]> {
  if (!/\.csv$/i.test(file.name)) {
    throw new Error("Batch upload now accepts CSV files only.");
  }
  const rows = parseCsvRows(await file.text());

  const parsed: BatchRecipientFileRow[] = [];
  for (let i = 0; i < rows.length; i++) {
    const row = rows[i] ?? [];
    const recipientRaw = String(row[0] ?? "").trim();
    const amountRaw = String(row[1] ?? "").trim();
    if (!recipientRaw && !amountRaw) continue;

    if (
      i === 0 &&
      recipientHeaderPattern.test(recipientRaw) &&
      /amount|value/i.test(amountRaw)
    ) {
      continue;
    }

    if (!recipientRaw) {
      throw new Error(`Missing recipient at row ${i + 1}.`);
    }

    const amountNum = Number(amountRaw);
    if (!Number.isFinite(amountNum) || amountNum <= 0) {
      throw new Error(`Invalid amount at row ${i + 1}: ${amountRaw}`);
    }

    parsed.push({
      recipient: recipientRaw,
      amount: amountRaw,
    });
  }

  if (parsed.length === 0) {
    throw new Error(
      "No valid rows found. Expected two columns: recipient, amount.",
    );
  }

  return parsed;
}
